import { NSCookiesHeader } from "./NSCookiesHeader";
import { NSReqHeader } from "./NSReqHeader";
import { NSResHeader } from "./NSResHeader";

export class NSHeader
{
    static cookies: NSCookiesHeader = new NSCookiesHeader();
    static req: NSReqHeader = new NSReqHeader();
    static res: NSResHeader = new NSResHeader();
}